
import { Icon, mergeStyles, useTheme } from '@fluentui/react';
import { useMemo } from 'react';

interface IProps {
    text: string;
    onClick?: () => void;
    primary?: boolean;
    icon?: "edit" | "view" | "merge" | "compare"
    disabled?: boolean;
}

const EditIcon = <Icon iconName="Edit" />;
const ViewIcon = <Icon iconName="View" />;
const CompareIcon = <Icon iconName="Compare" />;
const MergeIcon = <Icon iconName="Merge" />;

//TODO rename this to metro cards
const ActionCard = (props: IProps) => {
    const theme = useTheme();

    //TODO: move this to application/theme context
    const primaryClass = useMemo(() => {
        return mergeStyles({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '140px',
            backgroundColor: theme.palette.themePrimary,
            border: `1px solid ${theme.palette.themePrimary}`,
            cursor: 'pointer',
            fontSize: '16px',
            color: 'white',
            "&:hover": {
                backgroundColor: 'rgb(0, 90, 158)',
            }
        });
    }, []);


    //TODO: move this to application/theme context
    const disabledClass = useMemo(() => {
        return mergeStyles({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '140px',
            border: `1px solid darkgray`,
            backgroundColor: 'gray',
            fontSize: '16px',
            color: 'white',
        });
    }, []);


    const secondaryClass = useMemo(() => {
        return mergeStyles({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '140px',
            backgroundColor: theme.palette.themeLighter,
            cursor: 'pointer',
            fontSize: '16px',
            border: `1px solid ${theme.palette.themeLighter}`,
            color: 'gray',
            "&:hover": {
                backgroundColor: theme.palette.themeSecondary,
                color: 'white',
            }
        });
    }, []);

    const onRenderIcon = () => {
        switch (props.icon) {
            case "edit":
                return EditIcon;

            case "view":
                return ViewIcon;

            case "merge":
                return MergeIcon;

            case "compare":
                return CompareIcon;

            default:
                return null;

        }
    }

    let className = props.disabled
        ? disabledClass
        : props.primary
            ? primaryClass
            : secondaryClass;

    return (
        <div className={className}
            onClick={!props.disabled ? props.onClick : undefined}
            tabIndex={props.disabled ? undefined : 0}
            onKeyDown={(event) => {
                if (props.disabled)
                    return;

                // http://www.mit.edu/~rjc/aria/expandingSections.html#
                if (event.code === "Space" || event.code === "Enter") {
                    event.preventDefault();
                    props.onClick?.();
                }
            }}
        >
            <span style={{ marginLeft: '10px' }}>
                {onRenderIcon()}
            </span>
            <span style={{ padding: '8px', textAlign: 'left' }}>
                {props.text}
            </span>
        </div>
    );
}

export default ActionCard;

